import React, { useCallback } from 'react';
import { Modal } from '@npm-registry/eapteka-ui';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeModal,
  screenActions
} from '../../../store/screen';
import { AuthorizationSberIdForm } from '../AuthorizationSberIdForm';
import Styles from './AuthorizationSberIdModal.scss';
import { sendCloseAuthPopupEvent } from '../../../store/helpers';
import { getDescription } from '../../../store/screen/selectors';

export const AuthorizationSberIdModal = ({
  onClose
}: {
  onClose?: () => void;
}) => {
  const dispatch = useDispatch();
  const openAuthPopupEventDescription =
    useSelector(getDescription);

  const closeHandler = useCallback(() => {
    const trigger = openAuthPopupEventDescription?.trigger;

    if (trigger) {
      dispatch(screenActions.clearDescription());
    }

    sendCloseAuthPopupEvent();

    if (onClose) {
      onClose();
      return;
    }

    dispatch(closeModal());
  }, [
    dispatch,
    openAuthPopupEventDescription?.trigger,
    onClose
  ]);

  return (
    <Modal
      className={Styles.authorizationSberIdModalWrapper}
      classNameContainer={Styles.authorizationSberIdModal}
      onClose={closeHandler}
      visible
    >
      <AuthorizationSberIdForm
        onClose={closeHandler}
        isModal
      />
    </Modal>
  );
};
